import React from 'react'
import {Form, Select, Button, Row, Col, message, Table} from 'antd'
import {useState, useEffect} from 'react'
import {Spin} from 'antd'
import apiRequest from './hooks/apiRequest'

export default function ViewPolicyDetailsForFC(props) {
  const [claimCreationData, setClaimCreationData] = useState();
  console.log(props)
  useEffect(() => {fetchClaimData(props.parentToChild.claimInfo.id)}, [props.parentToChild])

  const fetchClaimData = async (claimId) => {
    try{
      const response = await apiRequest(process.env.REACT_APP_BASE_URL + `/Claim/GetClaimById/${claimId}`, 'GET')

      if(response.success)
      {
        setClaimCreationData(response.data.result.claim_creation);
      }
      // console.log('fetched data',response.data.result.claim_creation);
    }catch (error){
      console.error('Error fetching data:', error)
    }
  }

  async function updateStatus(val) {
    val.claim_status = 'Payment Approved'

    try{
      const response = await apiRequest(process.env.REACT_APP_BASE_URL + `/Claim/UpdateClaim/update`, 'POST', claimCreationData)
      if(response.success)
      {
        console.log("Status updated successfully!");
        props.onCloseModal()
      }
    }catch (error){
      console.error('Error:', error)
    }
  }

  async function updateStatusPaid(val) {
    val.claim_status = 'Paid'

    try{
      const response = await apiRequest(process.env.REACT_APP_BASE_URL + `/Claim/UpdateClaim/update`, 'POST', claimCreationData)
      if(response.success)
      {
        console.log("Status updated successfully!");
        props.onCloseModal2()
      }
    }catch (error){
      console.error('Error:', error)
    }

    // val.user_name = localStorage.getItem('username')
    // val.user_id = localStorage.getItem('loggedInUserID')
    // const requestMetadata = {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify(val),
    // }
    // debugger
    // fetch(
    //   process.env.REACT_APP_BASE_URL + '/claim/CreateClaim',
    //   requestMetadata,
    // )
    //   .then(res => res.json())
    //   .then(data => {
    //     window.location.reload()
    //   })
  }
  const columns = [
    {
      title: 'Risk Cover(s)',
      key: '1',
      render: x => x.policy_cover,
    },
    {
      title: 'Risk Item(s)',
      key: '2',
      render: x => x.riskitemname,
    },
    {
      title: 'Sum Insured',
      render: x => x.suminsured,
      key: '3',
    },
    {
      title: 'Premium',
      render: x => x.prorata,
      key: '4',
    },
  ]
  return (
    <>
      {props.parentToChild &&
        !props.parentToChild.policyNumber.includes('OTM') && (
          <div className="dash-bg-white">
            <Row gutter={[16, 24]}>
              <Col xs={12} sm={24} md={12} lg={12}>
                <h3
                  style={{
                    color: '#F15A2B',
                    fontWeight: '700',
                    fontSize: '20px',
                    margin: '0',
                  }}>
                  Policy Details
                </h3>
              </Col>
            </Row>
            <Row gutter={[16, 16]} style={{display: 'inline'}}>
              <Col xs={24} md={12} lg={5}>
                <label>
                  <b>Product : </b>
                  {props.parentToChild.product}
                </label>
              </Col>
              <Col xs={24} md={12} lg={7}>
                <label>
                  <b>Policy Number : </b>
                  {props.parentToChild.policyNumber}
                </label>
              </Col>
              <Col xs={24} md={12} lg={5}>
                <label>
                  <b>Customer Name : </b>
                  {props.parentToChild.customerName}
                </label>
              </Col>
              <Col xs={24} md={12} lg={7}>
                <label>
                  <b>National Id : </b>
                  {props.parentToChild.nationalId}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b>Policy Start Date : </b>
                  {props.parentToChild.policyStartDate}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b>Policy End Date : </b>
                  {props.parentToChild.policyEndDate}
                </label>
              </Col>
              <Col xs={24} md={12} lg={6}>
                <label>
                  <b>Policy Premium : </b>
                  {props.parentToChild.policyPremium}
                </label>
              </Col>
            </Row>
            <div className="table-grid-bx">
              <Table
                columns={columns}
                dataSource={props.parentToChild.riskItemDetails}
                scroll={{x: 768}}
                pagination={false}
              />
            </div>
          </div>
        )}
      {props.parentToChild && props.parentToChild.policyNumber.includes('OTM') && (
        <div className="dash-bg-white">
          <Row gutter={[16, 24]}>
            <Col xs={12} sm={24} md={12} lg={12}>
              <h3
                style={{
                  color: '#F15A2B',
                  fontWeight: '700',
                  fontSize: '20px',
                  margin: '0',
                }}>
                Policy Details
              </h3>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{display: 'inline'}}>
            <Col xs={24} md={12} lg={5}>
              <label>
                <b>Product : </b>
                {props.parentToChild.product}
              </label>
            </Col>
            <Col xs={24} md={12} lg={5}>
              <label>
                <b>Policy Number : </b>
                {props.parentToChild.policyNumber}
              </label>
            </Col>
            <Col xs={24} md={12} lg={7}>
              <label>
                <b>Customer Name : </b>
                {props.parentToChild.customerName}
              </label>
            </Col>
            <Col xs={24} md={12} lg={7}>
              <label>
                <b>National Id : </b>
                {props.parentToChild.nationalId}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Policy Start Date : </b>
                {props.parentToChild.policyStartDate}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Policy End Date : </b>
                {props.parentToChild.policyEndDate}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Policy Premium : </b>
                {props.parentToChild.policyPremium}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>VRN : </b>
                {props.parentToChild.VRN}
              </label>
            </Col>
          </Row>
        </div>
      )}
      <div className="dash-bg-white">
        <Row gutter={[16, 24]}>
          <Col xs={12} sm={24} md={12} lg={12}>
            <h3
              style={{
                color: '#F15A2B',
                fontWeight: '700',
                fontSize: '20px',
                margin: '0',
              }}>
              Claim Details
            </h3>
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{display: 'inline'}}>
          <Col xs={24} md={12} lg={6}>
            <label>
              <b>Claim No. : </b>
              {props.parentToChild &&
                props.parentToChild.claimInfo.claim_number}
            </label>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <label>
              <b>Created on : </b>
              {props.parentToChild &&
                props.parentToChild.claimInfo.created_date}
            </label>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <label>
              <b>Date of Loss : </b>
              {props.parentToChild &&
                props.parentToChild.claimInfo.date_of_loss}
            </label>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <label>
              <b>Notified on : </b>
              {props.parentToChild &&
                props.parentToChild.claimInfo.date_of_notification}
            </label>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <label>
              <b>Item : </b>
              {props.parentToChild && props.parentToChild.claimInfo.itemdetails}
            </label>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <label>
              <b>Amount approved : </b>
              {props.parentToChild &&
                props.parentToChild.claimInfo.approved_amount}
            </label>
          </Col>
        </Row>
      </div>

      {localStorage.getItem('roles') === '"FINANCE_CLERK"' && (
        <div className="align-right">
          <Button
            onClick={() => updateStatus(claimCreationData)}
            size="default"
            style={{
              backgroundColor: '#42cd6a',
              color: '#fff',
              padding: '0px 16px',
            }}>
            Approve Payment
          </Button>
        </div>
      )}
      {localStorage.getItem('roles') === '"FINANCE_MANAGER"' && (
        <div className="align-right">
          <Button
            onClick={() => updateStatusPaid(claimCreationData)}
            size="default"
            style={{
              backgroundColor: '#42cd6a',
              color: '#fff',
              padding: '0px 16px',
            }}>
            Change status to paid
          </Button>
        </div>
      )}
    </>
  )
}
